import { useEffect, useState } from 'react';
import { Switch, IconButton } from '@material-ui/core';
import { Button, TextField, Select, MenuItem } from '@mui/material';
import { Close } from '@material-ui/icons/';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CropFreeIcon from '@mui/icons-material/CropFree';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import Tooltip from '@mui/material/Tooltip';
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Slider, { SliderThumb, SliderValueLabelProps } from '@mui/material/Slider';
import { Card, Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { pCustomFilter } from "../../utils/parameters";

const CustomSlider = styled(Slider)(({ value }) => ({
    //color: '#52af77',
    color: `rgb(${(value*25.5)}, ${255 - (value*25.5)}, 0)`, // Cambia el color de fondo en función del valor
    // color: '#52af77',
    height: 8,
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&:before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: `rgb(${(value*25.5)}, ${255 - (value*25.5)}, 0)`,
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&:before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  }));

function CustomFilterCategory(props) {
    return (
        <div className={`sig_ST_CustomFilters_Category sig_ST_CustomFiltersCat${props.title.replace(/\s+/g, '')}`}>
            <p className='sig_ST_CustomFilters_Cat_Title sig_Home_ChangeOnDarkMode'>{props.title}</p>
            {props.children}
        </div>
    );
}

function CustomFiltersMenuClose (props) {
    return (  
        <IconButton className='sig_ST_CustomFilters_MenuClose sig_Home_ChangeOnDarkMode' onClick={props.handleFilterMenu}>
            <Close color="primary"/>
        </IconButton>
    );
}

export function CustomFilters (props, {handleFilterOptions}) {
    const { t } = useTranslation("global")

    const cFilterData = {
        orderAsc: {
            id: 0,
            label: t("sFilter.label_up")
        },
        orderDesc: {
            id: 1,
            label: t("sFilter.label_down")
        },
        showTerm: {
            id: 2,
            label: t("sFilter.label_term")
        },
        showDef: {
            id: 3,
            label: t("sFilter.label_definition")
        },
        showAccGreen: {
            id: 4,
            label: t("sFilter.label_recognition_complete")
        },
        showAccYellow: {
            id: 5,
            label: t("sFilter.label_recognition_partial")
        },
        showAccRed: {
            id: 6,
            label: t("sFilter.label_no_recognition")
        },
        complexSearch: {
            id: 7,
            label: t("sFilter.search_term_definition")
        }
    };

    /* MOB - This two const were joined in one nested object before, but caused issues when updating the active status 
    using the use state hook function, so for now it is divided between 'data' and 'state'. Check later if needed. */
    const [cFilterState, setCFilterState] = useState([
        true,  // orderAsc
        false, // orderDesc
        true,  // showTerm
        true,  // showDef
        true,  // showAccGreen
        true,  // showAccYellow
        true,  // showAccRed
        false  // complexSearch
    ]);

    function handleStateChange(e, ID){
        const newState = cFilterState.map((f, i) => {
            if ((i === ID) || ((ID === 0 && i === 1) || (ID === 1 && i === 0))) {
                return !f;
            } else {
                return f;
            }
        });
        setCFilterState(newState);
        props.handleFilterOptions(e, ID, newState); 
    }

    function CustomFilterRow(props) {
        return (
            <div className='sig_ST_CustomFilters_Filter'>
                {props.filterIcon != null ? 
                    <><SignLanguageIcon className={`sig_ST_SignIcon${props.filterIcon}`} /></> 
                : <></>}
                <span className='sig_ST_CustomFilters_Label'>{props.filterLabel}</span>
                <Switch color="primary" onClick={ (event) => {handleStateChange(event, props.filterID)}} checked={props.filterState} />
            </div>
        );
    }
    
    return (
        <div className={`sig_ST_CustomFilters_Root sig_Home_ChangeOnDarkMode_Bkg ${props.active ? '' : 'sig_ST_CustomFilters_RootHidden'}`}>
            <CustomFiltersMenuClose handleFilterMenu={props.handleFilterMenu}/>
            <CustomFilterCategory title={t("sFilter.cat_sort_by_term").toUpperCase()}>
                <CustomFilterRow 
                    filterLabel={cFilterData.orderAsc.label} 
                    filterID={cFilterData.orderAsc.id} 
                    filterState={cFilterState[cFilterData.orderAsc.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.orderDesc.label} 
                    filterID={cFilterData.orderDesc.id} 
                    filterState={cFilterState[cFilterData.orderDesc.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_information").toUpperCase()}>
                <CustomFilterRow 
                    filterLabel={cFilterData.showTerm.label} 
                    filterID={cFilterData.showTerm.id} 
                    filterState={cFilterState[cFilterData.showTerm.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.showDef.label} 
                    filterID={cFilterData.showDef.id} 
                    filterState={cFilterState[cFilterData.showDef.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_accesibility").toUpperCase()}>
                <CustomFilterRow 
                    filterIcon='GREEN'
                    filterLabel={cFilterData.showAccGreen.label} 
                    filterID={cFilterData.showAccGreen.id} 
                    filterState={cFilterState[cFilterData.showAccGreen.id]} />
                <CustomFilterRow 
                    filterIcon='YELLOW'
                    filterLabel={cFilterData.showAccYellow.label} 
                    filterID={cFilterData.showAccYellow.id} 
                    filterState={cFilterState[cFilterData.showAccYellow.id]} />
                <CustomFilterRow 
                    filterIcon='RED'
                    filterLabel={cFilterData.showAccRed.label} 
                    filterID={cFilterData.showAccRed.id} 
                    filterState={cFilterState[cFilterData.showAccRed.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_search").toUpperCase()}>
                <CustomFilterRow 
                    filterLabel={cFilterData.complexSearch.label} 
                    filterID={cFilterData.complexSearch.id} 
                    filterState={cFilterState[cFilterData.complexSearch.id]} />
            </CustomFilterCategory>
        </div>
    );
}

export function CustomBugFilters (props, {handleFilterOptions}) {
    const { t } = useTranslation("global")

    const cFilterData = {
        orderAsc: {
            id: 0,
            label: t("sFilter.label_up")
        },
        orderDesc: {
            id: 1,
            label: t("sFilter.label_down")
        },
        orderByTitle: {
            id: 2,
            label: t("sFilter.label_title")
        },
        orderByState: {
            id: 3,
            label: t("sFilter.label_state")
        },
        orderByModDate: {
            id: 4,
            label: t("sFilter.label_last_modification")
        },
        showUID: {
            id: 5,
            label: t("sFilter.label_show_user_id")
        },
        showStateNew: {
            id: 6,
            label: t("sFilter.label_new")
        },
        showStateOpen: {
            id: 7,
            label: t("sFilter.label_open")
        },
        showStatePending: {
            id: 8,
            label: t("sFilter.label_pending")
        },
        showStateResolved: {
            id: 9,
            label: t("sFilter.label_resolved")
        },
        showStateClosed: {
            id: 10,
            label:  t("sFilter.label_closed")
        },
        tagBug: {
            id: 11,
            label: "BUG"
        },
        tagDoc: {
            id: 12,
            label: "DOCUMENTACIÓN"
        },
        tagLSE: {
            id: 13,
            label: "LSE"
        },
        tagImp: {
            id: 14,
            label: "MEJORA"
        },
        tagPre: {
            id: 15,
            label: "PREDICCIÓN"
        },
        tagQue: {
            id: 16,
            label: "PREGUNTA"
        },
        tagWeb: {
            id: 17,
            label: "WEB"
        }
    };

    /* MOB - This two const were joined in one nested object before, but caused issues when updating the active status 
    using the use state hook function, so for now it is divided between 'data' and 'state'. Check later if needed. */
    const [cFilterState, setCFilterState] = useState([
        false, // orderAsc
        true,  // orderDesc
        false, // orderByTitle
        false, // orderByState
        true,  // orderByModDate
        true,  // showUID
        true,  // showStateNew
        true,  // showStateOpen
        true,  // showStatePending
        false, // showStateResolved
        false, // showStateClosed
        true,  // tagBug
        true,  // tagDoc
        true,  // tagLSE
        true,  // tagImp
        true,  // tagPre
        true,  // tagQue
        true   // tagWeb
    ]);

    // ( MOB - at this point might be better to separate the tags from the other options in the future )
    const tagIndexOffset = 11; // Start of Tags indexes, specified for readability 

    function handleStateChange(e, clickedID) {
        const newState = cFilterState.map((f, i) => {
            // MOB - Separating checks for improving readability
            // 'Order' Filter - Change both its state and the one of the other ordering option
            if ((clickedID === 0 && i === 1) || (clickedID === 1 && i === 0)) {
                return !f;
            }
            // 'Order By' Filter - Change both its state and the ones of the other two ordering options
            if ((clickedID >= 2 && clickedID <= 4) && (i >= 2 && i <= 4)) {
                if (cFilterState[clickedID] === false) {
                    if (i === clickedID) {
                        return true;
                    }
                    return false;
                } 
                return f;
            }
            // 'Tag' Filter / 'Show State' Filter - If the clicked 'tag' or 'show state' is found, change its state
            if (i === clickedID) {
                return !f;
            } 
            // Otherwise, keep the non-clicked filter state
            return f;
        });
        setCFilterState(newState);
        props.handleFilterOptions(e, clickedID, newState); 
    }

    function handleStateChangeAllTags(e, clickedID, clickedOption) {
        const newState = cFilterState.map((f, i) => {
            if (i < tagIndexOffset) {
                return f;
            } else {
                return clickedOption;
            }
        });
        setCFilterState(newState);
        props.handleFilterOptions(e, clickedID, newState);        
    }

    function CustomFilterRow(props) {
        return (
            <div className='sig_ST_CustomFilters_Filter sig_BugReport_CustomFilters_Filter'>
                {props.filterTag != null ? 
                    <>
                        <div className={`sig_BugReport_Tag ${props.filterState ? '' : 'sig_BugReportTag_Disabled '}sig_BugReport_Tag_${props.filterTag.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`}
                        onClick={ (event) => {handleStateChange(event, props.filterID)} } checked={props.filterState} >
                            {props.filterLabel}
                        </div>
                    </> 
                : 
                    <>
                        <span className='sig_ST_CustomFilters_Label'>{props.filterLabel}</span>
                        <Switch color="primary" onClick={ (event) => {handleStateChange(event, props.filterID)} } checked={props.filterState} />
                    </>}
            </div>
        );
    }
    
    return (
        <div className={`sig_ST_CustomFilters_Root sig_BugReport_CustomFilters_Root sig_Home_ChangeOnDarkMode_Bkg ${props.active ? '' : 'sig_ST_CustomFilters_RootHidden'}`}>
            <CustomFiltersMenuClose handleFilterMenu={props.handleFilterMenu}/>
            <CustomFilterCategory title={t("sFilter.cat_sort_by").toUpperCase()}>
                <CustomFilterRow 
                    filterLabel={cFilterData.orderByTitle.label} 
                    filterID={cFilterData.orderByTitle.id} 
                    filterState={cFilterState[cFilterData.orderByTitle.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.orderByState.label} 
                    filterID={cFilterData.orderByState.id} 
                    filterState={cFilterState[cFilterData.orderByState.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.orderByModDate.label} 
                    filterID={cFilterData.orderByModDate.id} 
                    filterState={cFilterState[cFilterData.orderByModDate.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_options").toUpperCase()}>
                <CustomFilterRow 
                    filterLabel={cFilterData.orderAsc.label} 
                    filterID={cFilterData.orderAsc.id} 
                    filterState={cFilterState[cFilterData.orderAsc.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.orderDesc.label} 
                    filterID={cFilterData.orderDesc.id} 
                    filterState={cFilterState[cFilterData.orderDesc.id]} />
                <CustomFilterRow 
                    filterLabel={cFilterData.showUID.label} 
                    filterID={cFilterData.showUID.id} 
                    filterState={cFilterState[cFilterData.showUID.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_show_states").toUpperCase()}>
                <CustomFilterRow 
                    filterTag='NEW'
                    filterLabel={cFilterData.showStateNew.label} 
                    filterID={cFilterData.showStateNew.id} 
                    filterState={cFilterState[cFilterData.showStateNew.id]} />
                <CustomFilterRow 
                    filterTag='OPEN'
                    filterLabel={cFilterData.showStateOpen.label} 
                    filterID={cFilterData.showStateOpen.id} 
                    filterState={cFilterState[cFilterData.showStateOpen.id]} />
                <CustomFilterRow 
                    filterTag='PENDING'
                    filterLabel={cFilterData.showStatePending.label} 
                    filterID={cFilterData.showStatePending.id} 
                    filterState={cFilterState[cFilterData.showStatePending.id]} />
                <CustomFilterRow 
                    filterTag='RESOLVED'
                    filterLabel={cFilterData.showStateResolved.label} 
                    filterID={cFilterData.showStateResolved.id} 
                    filterState={cFilterState[cFilterData.showStateResolved.id]} />
                <CustomFilterRow 
                    filterTag='CLOSED'
                    filterLabel={cFilterData.showStateClosed.label} 
                    filterID={cFilterData.showStateClosed.id} 
                    filterState={cFilterState[cFilterData.showStateClosed.id]} />
            </CustomFilterCategory>
            <CustomFilterCategory title={t("sFilter.cat_tags").toUpperCase()}>
                <div className='sig_BugReport_TagOptionsContainer'>                    
                    <Tooltip title={t("sBugReport.optionsSelectAll")} placement='top'>
                        <IconButton onClick={ (event) => {handleStateChangeAllTags(event, -1, true)} }>
                            <DoneAllIcon />
                        </IconButton>
                    </Tooltip>            
                    <Tooltip title={t("sBugReport.optionsDeselectAll")} placement='top'>
                        <IconButton onClick={ (event) => {handleStateChangeAllTags(event, -1, false)} }>
                            <RemoveDoneIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <CustomFilterRow 
                    filterTag='BUG'
                    filterLabel={cFilterData.tagBug.label} 
                    filterID={cFilterData.tagBug.id} 
                    filterState={cFilterState[cFilterData.tagBug.id]} />
                <CustomFilterRow 
                    filterTag='DOCUMENTACIÓN'
                    filterLabel={cFilterData.tagDoc.label} 
                    filterID={cFilterData.tagDoc.id} 
                    filterState={cFilterState[cFilterData.tagDoc.id]} />
                <CustomFilterRow 
                    filterTag='LSE'
                    filterLabel={cFilterData.tagLSE.label} 
                    filterID={cFilterData.tagLSE.id} 
                    filterState={cFilterState[cFilterData.tagLSE.id]} />
                <CustomFilterRow 
                    filterTag='MEJORA'
                    filterLabel={cFilterData.tagImp.label} 
                    filterID={cFilterData.tagImp.id} 
                    filterState={cFilterState[cFilterData.tagImp.id]} />
                <CustomFilterRow 
                    filterTag='PREDICCIÓN'
                    filterLabel={cFilterData.tagPre.label} 
                    filterID={cFilterData.tagPre.id} 
                    filterState={cFilterState[cFilterData.tagPre.id]} />
                <CustomFilterRow 
                    filterTag='PREGUNTA'
                    filterLabel={cFilterData.tagQue.label} 
                    filterID={cFilterData.tagQue.id} 
                    filterState={cFilterState[cFilterData.tagQue.id]} />
                <CustomFilterRow 
                    filterTag='WEB'
                    filterLabel={cFilterData.tagWeb.label} 
                    filterID={cFilterData.tagWeb.id} 
                    filterState={cFilterState[cFilterData.tagWeb.id]} />
            </CustomFilterCategory>
        </div>
    );

}

import TimelapseIcon from '@mui/icons-material/Timelapse';
import ShutterSpeedIcon from '@mui/icons-material/ShutterSpeed';


export function CustomWebcamOptions (props) {
    const { openOptionsMenu, setOpenOptionsMenu, optionsMenuState, setOptionsMenuState, blurSettings, setBlurSettings } = props;
    const { t } = useTranslation("global")
    
    const cOptionsData = {
        // setDuration: {
        //     id: 0,
        //     label: "Duración",
        //     icon: TimelapseIcon,
        // },
        sestOffset: {
            id: pCustomFilter.OFFSET,
            label: "Offset",
            icon: ShutterSpeedIcon,
        },
        showFraming: {
            id: pCustomFilter.FRAMING,
            label: t("sFilter.label_show_framing_help"),
            icon: CropFreeIcon,
        },
        activateKeypoints: {
            id: pCustomFilter.KPS,
            label: t("sFilter.label_show_kps"),
            icon: BlurOnIcon,
        },
        autoControl: {
            id: pCustomFilter.CONTROL,
            label: t("sFilter.label_control"),
            icon: ControlCameraIcon,
        },
        activateVirtualBG: {
            id: pCustomFilter.VIRTUALBG,
            label: t("sFilter.label_virtualBG"),
            icon: ControlCameraIcon,
        }
    };

    function handleStateChange(e, ID){
        // console.log("🚀 ~ file: CustomFilters.js:519 ~ handleStateChange ~ handleStateChange:", ID)
        

        const newState = optionsMenuState.map((f, i) => {
            if (i === ID) {
                return !f;
            } else {
                return f;
            }
        });
        setOptionsMenuState(newState);
    }


    // useEffect(() => {
    //     console.log("🚀 ~ file: CustomFilters.js:541 ~ CustomWebcamOptions ~ optionsMenuState:", optionsMenuState)
    // },[optionsMenuState]);



    useEffect(() => {
        if (optionsMenuState[cOptionsData.activateVirtualBG.id] === false){
            setBlurSettings({
                'blur': 0,
                'image': false
            })
        }
    },[optionsMenuState[cOptionsData.activateVirtualBG.id]]);

    function CustomOptionsRow(props) {
        return (
            <div className={`sig_ST_CustomFilters_Filter ${ props.filterDisabled ? 'sig_WebcamOptions_Disabled' : ''}`}>
                {props.filterIcon != null ? 
                    <><props.filterIcon className="sig_WebcamOptions_Icon" /></> 
                : <></>}
                <span className='sig_ST_CustomFilters_Label'>{props.filterLabel}</span>
                {props.filterDisabled ? 
                    <Switch disabled/>
                : 
                    <Switch color="primary" onClick={ (event) => {handleStateChange(event, props.filterID)}} checked={props.filterState} />
                }
            </div>
        );
    }

    function onClickCheckbox(selected) {
        if (selected === 'BLUR'){
            setBlurSettings(prevState => {
                if (prevState.blur === 0) {
                  return {
                    ...prevState,
                    blur: 5
                  };
                } else {
                  return {
                    ...prevState,
                    blur: 0
                  };
                }
            });
        }else{
            setBlurSettings(prevState => {
                return {
                  ...prevState,
                  image: !prevState.image
                };
            });
        }
    }

    const handleSliderChange = (event) => {
        setBlurSettings({
          ...blurSettings,  // Mantén los valores actuales de 'score' y 'comment'
          'blur': event.target.value   // Cambia el valor de 'validation' con el nuevo valor
        });
    };
    
    return (
        <div className={`sig_ST_CustomFilters_Root sig_WebcamOptions_Root sig_Home_ChangeOnDarkMode_Bkg ${props.openOptionsMenu ? '' : 'sig_ST_CustomFilters_RootHidden'}`}>
            <CustomFiltersMenuClose handleFilterMenu={() => setOpenOptionsMenu(false)}/>
            <CustomFilterCategory title={t("sFilter.cat_configuration").toUpperCase()}>
                {/* <CustomOptionsRow 
                    filterDisabled={false}
                    filterIcon={cOptionsData.sestOffset.icon}
                    filterLabel={cOptionsData.sestOffset.label} 
                    filterID={cOptionsData.sestOffset.id} 
                    filterState={optionsMenuState[cOptionsData.sestOffset.id]} /> */}
                <CustomOptionsRow 
                    filterDisabled={false}
                    filterIcon={cOptionsData.showFraming.icon}
                    filterLabel={cOptionsData.showFraming.label} 
                    filterID={cOptionsData.showFraming.id} 
                    filterState={optionsMenuState[cOptionsData.showFraming.id]} />

                {props.userAdmin === true ?
                    <>
                    <CustomOptionsRow 
                        filterDisabled={false}
                        filterIcon={cOptionsData.activateKeypoints.icon}
                        filterLabel={cOptionsData.activateKeypoints.label} 
                        filterID={cOptionsData.activateKeypoints.id} 
                        filterState={optionsMenuState[cOptionsData.activateKeypoints.id]} />
                    <CustomOptionsRow 
                        filterDisabled={!optionsMenuState[pCustomFilter.KPS]}
                        filterIcon={cOptionsData.autoControl.icon}
                        filterLabel={cOptionsData.autoControl.label} 
                        filterID={cOptionsData.autoControl.id} 
                        filterState={optionsMenuState[cOptionsData.autoControl.id]} />
                    

                    {/* <CustomOptionsRow 
                        filterDisabled={false}
                        filterIcon={cOptionsData.activateVirtualBG.icon}
                        filterLabel={cOptionsData.activateVirtualBG.label} 
                        filterID={cOptionsData.activateVirtualBG.id} 
                        filterState={optionsMenuState[cOptionsData.activateVirtualBG.id]} /> */}

                    {(optionsMenuState[cOptionsData.activateVirtualBG.id]) 
                        ? <>
                        
                        <Card elevation={0}>
                            <div className='sig_Teams_Info_Root'>
                            <div className='sig_Teams_MainContainer'>
                                <div style={{display: 'flex', alignItems: 'center' }}>
                                    <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('IMAGE')} checked={blurSettings['image']> 0} />
                                    Fondo
                                </div>
                                <div style={{display: 'flex', alignItems: 'center' }}>
                                    <Checkbox style={{marginRight: '5px'}} onClick={() => onClickCheckbox('BLUR')} checked={blurSettings['blur']> 0} />
                                    Desenfoque

                                    { blurSettings['blur']> 0 ?
                                        (
                                            <>
                                            <div style={{display: 'flex', width: '100%', marginLeft: '10%'}}>
                                                <CustomSlider
                                                valueLabelDisplay="auto"
                                                aria-label="pretto slider"
                                                onChange={ handleSliderChange }
                                                value={  blurSettings['blur'] }
                                                min={1}
                                                max={10}
                                                />
                                                <TextField 
                                                    variant="outlined"
                                                    type="number"
                                                    style={{width: '60%', marginLeft: '10%'}}
                                                    fullWidth
                                                    inputProps={{ min: 1, max: 10, step: 1 }}
                                                    value={ blurSettings['blur'] }
                                                    onChange={ handleSliderChange }
                                                    InputProps={{
                                                        style: {
                                                        height: '35px'
                                                        },
                                                    }}
                                                />
                                            </div>
                                            </>
                                        ): <></> }


                                </div>

                                

                                
                            </div>
                            </div>
                        </Card>
                            
                        
                        </>
                        : <></>
                    }
                    </> 
                :<></>}

                

                



                    
            </CustomFilterCategory>
        </div>
    );
}